import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

export default function TabNav({ level, handlePostNavTab, tab }) {
  return (
    <Nav tabs className="bg-primary border-0">
      <NavItem onClick={() => handlePostNavTab(1)}>
        <NavLink
          className={
            tab === 1 ? "active text-primary border-0" : "text-white border-0"
          }
        >
          <FontAwesomeIcon icon="map" />
          &nbsp; <FormattedMessage id="Admin" />
        </NavLink>
      </NavItem>

      <NavItem onClick={() => handlePostNavTab(2)}>
        <NavLink
          className={
            tab === 2 ? "active text-primary border-0" : "text-white border-0"
          }
        >
          <FontAwesomeIcon icon="book-open" />
          &nbsp; <FormattedMessage id="Courses" />
        </NavLink>
      </NavItem>

      <NavItem onClick={() => handlePostNavTab(3)}>
        <NavLink
          className={
            tab === 3 ? "active text-primary border-0" : "text-white border-0"
          }
        >
          <FontAwesomeIcon icon="chart-pie" />
          &nbsp; <FormattedMessage id="ResultsOverview" />
        </NavLink>
      </NavItem>
      {level === "class" ? (
        <>
          <NavItem onClick={() => handlePostNavTab(5)}>
            <NavLink
              className={
                tab === 5
                  ? "active text-primary border-0"
                  : "text-white border-0"
              }
            >
              <FontAwesomeIcon icon="chalkboard-teacher" />
              &nbsp;
              <FormattedMessage id="Documents" />
            </NavLink>
          </NavItem>
        </>
      ) : (
        ""
      )}
      <NavItem onClick={() => handlePostNavTab(7)}>
        <NavLink
          style={{ isolation: "isolate" }}
          className={
            tab === 7 ? "active text-primary border-0" : "text-white border-0"
          }
        >
          <FontAwesomeIcon icon="briefcase" />
          &nbsp; <FormattedMessage id="APL" />
        </NavLink>
      </NavItem>
    </Nav>
  );
}
